let genders = ["M","F","Pair"];
export { genders }
let adultGenders = ["M","F"];
export {adultGenders}